import { useIsPartnerApp } from "@/store/selectors/featureSelectors";
import { PartnerDashboard } from "./PartnerDashboard";
import { PlaylistLibrary } from "./PlaylistLibrary";

export function PlaylistRoutePageWrapper() {
  const isPartnerApp = useIsPartnerApp();

  if (isPartnerApp) {
    return <PartnerDashboard />;
  }
  return <PlaylistLibrary />;
}
